module.exports = __webpack_public_path__ + "img/auth_transition.ab8924f0.png";